export const Divider = () => (
  <svg
    width="256"
    height="5"
    viewBox="0 0 256 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="2" cy="2.5" r="2" fill="currentColor" />
    <circle cx="20" cy="2.5" r="2" fill="currentColor" />
    <circle cx="56" cy="2.5" r="2" fill="currentColor" />
    <circle cx="38" cy="2.5" r="2" fill="currentColor" />
    <circle cx="74" cy="2.5" r="2" fill="currentColor" />
    <circle cx="92" cy="2.5" r="2" fill="currentColor" />
    <circle cx="128" cy="2.5" r="2" fill="currentColor" />
    <circle cx="110" cy="2.5" r="2" fill="currentColor" />
    <circle cx="146" cy="2.5" r="2" fill="currentColor" />
    <circle cx="164" cy="2.5" r="2" fill="currentColor" />
    <circle cx="200" cy="2.5" r="2" fill="currentColor" />
    <circle cx="182" cy="2.5" r="2" fill="currentColor" />
    <circle cx="218" cy="2.5" r="2" fill="currentColor" />
    <circle cx="236" cy="2.5" r="2" fill="currentColor" />
    <circle cx="254" cy="2.5" r="2" fill="currentColor" />
  </svg>
)
